import { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Accordion } from 'react-bootstrap';
import Tippy from '@tippyjs/react';
import Select from 'react-select';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AccordionToggleWithButtonForRole } from '../common';
import { SelectPermission } from '.';

const EditRole = ({
  handleUpdateRole,
  handleShowUpdateRole,
  showUpdateRole,
  editPermissionList,
  editSelectedPermissionList,
  editTypesList,
  editRoleName,
  editRoleId,
  selectedUserTypeId,
  sitesList,
  siteAccessInfo,
}) => {
  const [toggleArrowChange, arrowChange] = useState(false);
  const [typeList, typeListSet] = useState([]);
  const [permissionsList, permissionsListSet] = useState([]);
  const [permissionsListFinal, permissionsListFinalSet] = useState({});
  const [selectedPermissionsList, selectedPermissionsListSet] = useState([]);
  const [roleName, roleNameSet] = useState('');
  const [userTypes, setUserTypes] = useState(''); // This removed

  const arrowChangeToggle = () => {
    arrowChange(!toggleArrowChange);
  };

  const userTypeChange = (valueUT) => {
    const typeNameIndex = permissionsList.findIndex(
      (item) => item.typeId === valueUT
    );
    if (typeNameIndex > -1) {
      permissionsListFinalSet(permissionsList[typeNameIndex].permissions);
    }
  };

  const siteOptions =
    sitesList?.length > 0
      ? sitesList.map((site) => ({
          value: site._id,
          label: site.siteName,
        }))
      : [];

  const mangerType =
    editTypesList?.length > 0 &&
    editTypesList.find((item) => item.label === 'Manager');

  useEffect(() => {
    permissionsListSet(editPermissionList);
    typeListSet(editTypesList);
    selectedPermissionsListSet(editSelectedPermissionList);
    roleNameSet(editRoleName);

    const typeNameIndex = permissionsList.findIndex(
      (item) => item.typeId === selectedUserTypeId
    );
    if (typeNameIndex > -1) {
      permissionsListFinalSet(permissionsList[typeNameIndex].permissions);
    }
    setUserTypes(selectedUserTypeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    editTypesList,
    editPermissionList,
    editRoleName,
    editSelectedPermissionList,
    editRoleId,
    permissionsList,
    userTypes,
  ]);

  return (
    <>
      <Modal
        show={showUpdateRole}
        onHide={() => {
          handleShowUpdateRole(false);
        }}
        centered
      >
        <Modal.Header>
          <Modal.Title className="m-0">Edit Role</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              handleShowUpdateRole(false);
            }}
          />
        </Modal.Header>
        <Formik
          enableReinitialize
          initialValues={{
            editRoleId,
            roleName,
            userType: userTypes || [],
            siteId:
              siteAccessInfo?.siteIds?.length > 0
                ? siteAccessInfo.siteIds.map((site) => site._id)
                : [],
            selectedPermissions: selectedPermissionsList || [],
          }}
          validationSchema={Yup.object({
            roleName: Yup.string().required('Please enter a name'),
            userType: Yup.string().required('Please select user type'),
            selectedPermissions: Yup.array().min(
              1,
              'Please select at least one permission'
            ),
          })}
          onSubmit={(values) => {
            handleUpdateRole(values);
          }}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit}>
              <Modal.Body>
                <section>
                  <Form.Group controlId="worksessionType">
                    <Form.Label>Role Name</Form.Label>
                    <Field
                      className="form-control"
                      type="text"
                      placeholder="Enter role name"
                      name="roleName"
                    />
                    <ErrorMessage
                      name="roleName"
                      render={(msg) => (
                        <small className="text-danger">{msg}</small>
                      )}
                    />
                  </Form.Group>

                  <Form.Group controlId="type">
                    <Form.Label className="w-100">
                      <div className="float-start">
                        User Type
                        <Tippy
                          content={`${'Default type to inherit permission from'}`}
                          theme="light"
                          key="2"
                        >
                          <span className="p-2 d-inline-block">
                            <i className="mdi mdi-information-outline" />
                          </span>
                        </Tippy>
                      </div>
                      <div className="float-end">
                        <ul className="nav">
                          <li className="nav-item ">
                            <Link
                              to="/help/permissions"
                              className="nav-link nav-underline text-decoration-underline"
                              target="_blank"
                              rel="noreferrer"
                            >
                              User type permissions
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </Form.Label>
                    <Select
                      name="userType"
                      options={typeList}
                      defaultValue={editTypesList.filter(
                        (item) => item.isSelected
                      )}
                      onChange={(e) => {
                        const selectedUT = e.value;
                        formikprops.setFieldValue('userType', selectedUT);
                        formikprops.setFieldValue(
                          'selectedPermissions',
                          selectedUT === selectedUserTypeId
                            ? editSelectedPermissionList
                            : []
                        );
                        userTypeChange(selectedUT);
                      }}
                    />
                    <ErrorMessage
                      name="userType"
                      render={(msg) => (
                        <small className="text-danger">{msg}</small>
                      )}
                    />
                  </Form.Group>

                  {formikprops.values.userType === mangerType?.value &&
                    siteOptions?.length > 0 && (
                      <Form.Group controlId="siteId">
                        <Form.Label>Select Sites</Form.Label>
                        <Select
                          isMulti
                          name="siteId"
                          options={siteOptions}
                          defaultValue={
                            siteAccessInfo?.siteIds?.length > 0
                              ? siteAccessInfo.siteIds.map((site) => ({
                                  value: site._id,
                                  label: site.siteName,
                                }))
                              : []
                          }
                          onChange={(sOptions) => {
                            if (sOptions.length) {
                              formikprops.setFieldValue(
                                'siteId',
                                sOptions.map((item) => item.value)
                              );
                            } else {
                              formikprops.setFieldValue('siteId', []);
                            }
                          }}
                          placeholder="Select sites"
                          className="site-multi-select"
                          classNamePrefix="select"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary: '#0649b5',
                              neutral10: '#edf2f9',
                              neutral20: '#d2ddec',
                              neutral30: '#d2ddec',
                              neutral50: '#b1c2da',
                              neutral80: '#12263f',
                              dangerLight: '#DEEBFF',
                              danger: '#12263f',
                            },
                          })}
                        />
                        <ErrorMessage
                          name="client"
                          render={(msg) => (
                            <small className="text-danger">{msg}</small>
                          )}
                        />
                      </Form.Group>
                    )}

                  <div>
                    <h4 className="mb-3">Select Permissions</h4>
                  </div>

                  <div className="card mb-0">
                    <div className="card-body p-0">
                      <ul className="list-group list-group-flush pe-0">
                        <Accordion
                          defaultActiveKey="0"
                          className="accordion-flush"
                        >
                          {permissionsListFinal &&
                            permissionsListFinal.length > 0 &&
                            permissionsListFinal.map((permission, index) => (
                              <li className="list-group-item" key={index}>
                                <Row>
                                  <Col className="px-2">
                                    <div className="d-flex justify-content-start text-capitalize">
                                      {permission.name}
                                    </div>
                                  </Col>
                                  <Col sm lg="1">
                                    <div className="d-flex justify-content-end">
                                      <AccordionToggleWithButtonForRole
                                        eventKey={index + 1}
                                        callback={arrowChangeToggle}
                                      />
                                    </div>
                                  </Col>
                                </Row>

                                <Accordion.Collapse eventKey={index + 1}>
                                  <div className="p-2">
                                    {permission.list &&
                                      permission.list.length > 0 &&
                                      permission.list.map((item, i) => (
                                        <SelectPermission
                                          permissionNameLabel={
                                            item.permissionNameUI
                                          }
                                          key={i}
                                          permissionName={item.permissionName}
                                          formikprops={formikprops}
                                        />
                                      ))}
                                  </div>
                                </Accordion.Collapse>
                              </li>
                            ))}
                        </Accordion>
                      </ul>
                    </div>
                  </div>
                  <ErrorMessage
                    name="selectedPermissions"
                    render={(msg) => (
                      <small className="text-danger">{msg}</small>
                    )}
                  />
                </section>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between">
                <Button
                  variant="link"
                  onClick={() => {
                    handleShowUpdateRole(false);
                  }}
                >
                  Cancel
                </Button>
                <Button variant="primary" type="submit">
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

EditRole.propTypes = {
  handleUpdateRole: PropTypes.func,
  handleShowUpdateRole: PropTypes.func,
  showUpdateRole: PropTypes.bool,
  editPermissionList: PropTypes.array,
  editSelectedPermissionList: PropTypes.array,
  editTypesList: PropTypes.array,
  editRoleName: PropTypes.string,
  editRoleId: PropTypes.string,
  selectedUserTypeId: PropTypes.string,
  sitesList: PropTypes.array,
  siteAccessInfo: PropTypes.object,
};

export default EditRole;
